import React, {PureComponent} from "react";
import Confirm from "./Confirm";
import {FormattedMessage, injectIntl} from "react-intl";
import {humanizeDayOfWeek, serverDayDate, serverShortTime} from "../Common/Helpers";
import {withStyles} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Store from '../Store';
import FullPageLoader from "./FullPageLoader";
import {scheduleMeeting} from "../Containers/Welcome/Actions";
import Sizes from '../Assets/Sizes';
import styled from 'styled-components';
import {isNonEmptyObject} from "@tomeravni/easybizy-js-common/common";

function TransitionUp(props) {
    return <Slide {...props} direction="up"/>;
}

const DialogWrapper = styled.div`
    position: relative;
    z-index: 101;

    .mdc-dialog__body {
        margin-bottom: 0;
    }
`;

const TextArea = styled.textarea`
    resize: none;
    height: 6em;
    width: 100%;
    border: 1px solid ${p => p.theme.colors.safeText};
    border-radius: ${Sizes.listItemBorderRadius};
    margin-top: 1em;
    font-size: ${Sizes.sloganTextSize};
    overflow: auto;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    font-family: inherit;
`;

const InvisibleInput = styled.input`
    visibility: hidden;
    height: 0;
    width: 0;
    position: absolute;
`

class AppointmentApprovalDialog extends PureComponent {
    state = {
        toastVisible: false,
        requiresCard: false,
        enableRemarks: false,
        remarks: '',
        dirty: {}
    };

    updateField(fieldName, event) {
        let value = event.target.value;
        this.setState({[fieldName]: value}, () => {
        });
    }

    confirm(option, enableRemarks, forceRemarks, remarksPlaceholder) {
        this.setState({
            enableRemarks, forceRemarks, remarksPlaceholder
        })

        return new Promise((resolve, reject) => {
            const title = this.props.intl.formatMessage({id: 'schedule.createMeetingDialogTitle'});
            const body = (<span><FormattedMessage
                id="schedule.createMeetingDialogContent"/>&nbsp;{humanizeDayOfWeek(option.Start)}&nbsp;{serverDayDate(option.Start)},<br/>
			<FormattedMessage
                id="schedule.atTime"/>:&nbsp;{serverShortTime(option.Start)}.</span>);

            this.dialog.show(title, body, (accept) => {
                if (accept) {
                    return this.accept(option, resolve, reject);

                }
            });
        });
    }

    accept(option, resolve, reject) {
        const savingMeetingTitle = this.props.intl.formatMessage({id: 'schedule.creatingYourMeeting'});
        this.savingMeetingLoader.load(savingMeetingTitle);
        const store = Store.getState().schedule;
        let genderMap;
        if (isNonEmptyObject(store.itemsGenderMap)) {
            let gendersMap = store.itemsGenderMap.asMutable();
            genderMap = Object.keys(gendersMap).reduce((acc, curr) => ([...acc, {
                onlineBookingId: parseInt(curr),
                genders: gendersMap[curr]
            }]), []);
        }

        let quantityMap;
        if (isNonEmptyObject(store.itemsQuantityMap)) {
            const quantitiesMap = store.itemsQuantityMap.asMutable();
            quantityMap = Object.keys(quantitiesMap).reduce((acc, curr) => ([...acc, {
                onlineBookingId: parseInt(curr),
                quantity: parseInt(quantitiesMap[curr].split('_')[0]),
                schedulingPolicy: quantitiesMap[curr].split('_')[1]
            }]), []);

        }

        Store.dispatch(scheduleMeeting(store.config.Token, store.services.map(service => service.OnlineBookingServiceId).join(','), option.EmployeeId, option.Start, option.End,
            option.InternalAvailabilities, option.RoomId, this.state.remarks, genderMap, quantityMap, (err, result) => {
                if (err) {
                    this.savingMeetingLoader.error(err.message);
                    reject(err);
                } else {
                    resolve(result);
                }
            }));
    }

    hideToast = () => {
        this.setState({
            error: null,
            toastVisible: false
        })
    };


    render() {
        const ltr = !this.props.intl.locale.includes('he');
        return <DialogWrapper>
            <Confirm ref={dialog => this.dialog = dialog} ltr={ltr}
                     disabled={this.state.forceRemarks && this.state.remarks.length < 2}>
                <div>
                    <InvisibleInput autoFocus={true}/>

                    {(this.state.enableRemarks || this.state.forceRemarks) &&
                        <TextArea
                            onChange={this.updateField.bind(this, 'remarks')}
                            tabIndex="-1"
                            placeholder={this.state.remarksPlaceholder || this.props.intl.formatMessage({id: 'schedule.remarks'})}/>
                    }

                </div>

            </Confirm>

            <FullPageLoader ref={r => this.savingMeetingLoader = r}/>
            <Snackbar
                TransitionComponent={TransitionUp}
                open={this.state.toastVisible}
                onClose={this.hideToast}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{this.state.error}</span>}
            />
        </DialogWrapper>
    }
}

export default injectIntl(withStyles({})(AppointmentApprovalDialog), {withRef: true});
